import './App.css'
import * as React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom'
import appSettings from './appSettings';
import { RestorePage } from './pages/restore';
import { ResetPasswordPage } from './pages/reset';
import { ActivatePatronPage } from "./pages/activate";

class App extends React.Component {
    public render() {
        return (
            <Router basename={appSettings.REACT_APP_ROOT_URL}>
                <React.Fragment>
                    <Route exact={true} path='/' component={RestorePage} />
                    <Route path='/restore' component={RestorePage} />
                    <Route path='/reset' component={ResetPasswordPage} />
                    <Route path='/activate' component={ActivatePatronPage} />
                </React.Fragment>
            </Router>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx